import { DeleteGroup } from 'api/groups-endpoint';
import ConfirmButton from 'components/ConfirmButton';
import useOperationAuthorizationChecks from 'hooks/useOperationAuthorizationChecks';
import { getLinkToCreateGroup } from 'navigator/links';
import { useNavigate } from 'react-router-dom';
import { useGroupsContext } from 'stores/groups-context';
import { Group } from 'types/group';
import { UserOperations } from 'types/user';

interface DeleteGroupButtonProps {
  group: Group;
  className?: string;
  onDeleteFail: (message: string) => void;
}

function DeleteGroupButton({ group, className, onDeleteFail }: DeleteGroupButtonProps): JSX.Element {
  const groupsContext = useGroupsContext();
  const navigate = useNavigate();
  const canDeleteGroup = useOperationAuthorizationChecks([UserOperations.GROUP_DELETE]);

  if (!canDeleteGroup) {
    return <></>;
  }

  const handleClick = async () => {
    const response = await DeleteGroup(group);
    if (response.success) {
      groupsContext.fetchData();
      navigate(getLinkToCreateGroup());
    } else {
      onDeleteFail(response.message || '');
    }
  };

  return <ConfirmButton label='Delete Group' onClick={handleClick} className={className} />;
}

DeleteGroupButton.defaultProps = {
  className: undefined,
};

export default DeleteGroupButton;
